import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  Char__rangeTo_impl_tkncvpnglpnjmwahwh as Char__rangeTo_impl_tkncvp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance2wec3srl1ini as Companion_instance } from './AsciiBitSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ILLEGAL_HEADER_NAME_CHARS() {
  _init_properties_HttpHeaders_kt__8vtb1o();
  return ILLEGAL_HEADER_NAME_CHARS;
}
var ILLEGAL_HEADER_NAME_CHARS;
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.Accept_1 = 'Accept';
        this.AcceptCharset_1 = 'Accept-Charset';
        this.AcceptEncoding_1 = 'Accept-Encoding';
        this.AcceptLanguage_1 = 'Accept-Language';
        this.AcceptRanges_1 = 'Accept-Ranges';
        this.Age_1 = 'Age';
        this.Allow_1 = 'Allow';
        this.ALPN_1 = 'ALPN';
        this.AuthenticationInfo_1 = 'Authentication-Info';
        this.Authorization_1 = 'Authorization';
        this.CacheControl_1 = 'Cache-Control';
        this.Connection_1 = 'Connection';
        this.ContentDisposition_1 = 'Content-Disposition';
        this.ContentEncoding_1 = 'Content-Encoding';
        this.ContentLanguage_1 = 'Content-Language';
        this.ContentLength_1 = 'Content-Length';
        this.ContentLocation_1 = 'Content-Location';
        this.ContentRange_1 = 'Content-Range';
        this.ContentType_1 = 'Content-Type';
        this.Cookie_1 = 'Cookie';
        this.DASL_1 = 'DASL';
        this.Date_1 = 'Date';
        this.DAV_1 = 'DAV';
        this.Depth_1 = 'Depth';
        this.Destination_1 = 'Destination';
        this.ETag_1 = 'ETag';
        this.Expect_1 = 'Expect';
        this.Expires_1 = 'Expires';
        this.From_1 = 'From';
        this.Forwarded_1 = 'Forwarded';
        this.Host_1 = 'Host';
        this.HTTP2Settings_1 = 'HTTP2-Settings';
        this.If_1 = 'If';
        this.IfMatch_1 = 'If-Match';
        this.IfModifiedSince_1 = 'If-Modified-Since';
        this.IfNoneMatch_1 = 'If-None-Match';
        this.IfRange_1 = 'If-Range';
        this.IfScheduleTagMatch_1 = 'If-Schedule-Tag-Match';
        this.IfUnmodifiedSince_1 = 'If-Unmodified-Since';
        this.LastModified_1 = 'Last-Modified';
        this.Location_1 = 'Location';
        this.LockToken_1 = 'Lock-Token';
        this.Link_1 = 'Link';
        this.MaxForwards_1 = 'Max-Forwards';
        this.MIMEVersion_1 = 'MIME-Version';
        this.OrderingType_1 = 'Ordering-Type';
        this.Origin_1 = 'Origin';
        this.Overwrite_1 = 'Overwrite';
        this.Position_1 = 'Position';
        this.Pragma_1 = 'Pragma';
        this.Prefer_1 = 'Prefer';
        this.PreferenceApplied_1 = 'Preference-Applied';
        this.ProxyAuthenticate_1 = 'Proxy-Authenticate';
        this.ProxyAuthenticationInfo_1 = 'Proxy-Authentication-Info';
        this.ProxyAuthorization_1 = 'Proxy-Authorization';
        this.PublicKeyPins_1 = 'Public-Key-Pins';
        this.PublicKeyPinsReportOnly_1 = 'Public-Key-Pins-Report-Only';
        this.Range_1 = 'Range';
        this.Referrer_1 = 'Referer';
        this.RetryAfter_1 = 'Retry-After';
        this.ScheduleReply_1 = 'Schedule-Reply';
        this.ScheduleTag_1 = 'Schedule-Tag';
        this.SecWebSocketAccept_1 = 'Sec-WebSocket-Accept';
        this.SecWebSocketExtensions_1 = 'Sec-WebSocket-Extensions';
        this.SecWebSocketKey_1 = 'Sec-WebSocket-Key';
        this.SecWebSocketProtocol_1 = 'Sec-WebSocket-Protocol';
        this.SecWebSocketVersion_1 = 'Sec-WebSocket-Version';
        this.Server_1 = 'Server';
        this.SetCookie_1 = 'Set-Cookie';
        this.SLUG_1 = 'SLUG';
        this.StrictTransportSecurity_1 = 'Strict-Transport-Security';
        this.TE_1 = 'TE';
        this.Timeout_1 = 'Timeout';
        this.Trailer_1 = 'Trailer';
        this.TransferEncoding_1 = 'Transfer-Encoding';
        this.Upgrade_1 = 'Upgrade';
        this.UserAgent_1 = 'User-Agent';
        this.Vary_1 = 'Vary';
        this.Via_1 = 'Via';
        this.Warning_1 = 'Warning';
        this.WWWAuthenticate_1 = 'WWW-Authenticate';
        this.AccessControlAllowOrigin_1 = 'Access-Control-Allow-Origin';
        this.AccessControlAllowMethods_1 = 'Access-Control-Allow-Methods';
        this.AccessControlAllowCredentials_1 = 'Access-Control-Allow-Credentials';
        this.AccessControlAllowHeaders_1 = 'Access-Control-Allow-Headers';
        this.AccessControlRequestMethod_1 = 'Access-Control-Request-Method';
        this.AccessControlRequestHeaders_1 = 'Access-Control-Request-Headers';
        this.AccessControlExposeHeaders_1 = 'Access-Control-Expose-Headers';
        this.AccessControlMaxAge_1 = 'Access-Control-Max-Age';
        this.XHttpMethodOverride_1 = 'X-Http-Method-Override';
        this.XForwardedHost_1 = 'X-Forwarded-Host';
        this.XForwardedServer_1 = 'X-Forwarded-Server';
        this.XForwardedProto_1 = 'X-Forwarded-Proto';
        this.XForwardedFor_1 = 'X-Forwarded-For';
        this.XForwardedPort_1 = 'X-Forwarded-Port';
        this.XRequestId_1 = 'X-Request-ID';
        this.XCorrelationId_1 = 'X-Correlation-ID';
        this.XTotalCount_1 = 'X-Total-Count';
        this.LastEventID_1 = 'Last-Event-ID';
        this.TDMReservation_1 = 'TDM-Reservation';
        this.TDMPolicy_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.UnsafeHeadersArray_1 = ['Transfer-Encoding', 'Upgrade'];
        this.UnsafeHeadersList_1 = asList(this.UnsafeHeadersArray_1);
      }
      checkHeaderName_cxkzpm_k$(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (get_ILLEGAL_HEADER_NAME_CHARS().contains_egozq6_k$(item)) {
            throw IllegalHeaderNameException().new_io_ktor_http_IllegalHeaderNameException_97zbc3_k$(name, _unary__edvuaz);
          }
        }
      }
      checkHeaderValue_67110u_k$(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().new_io_ktor_http_IllegalHeaderValueException_fgjd27_k$(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(header) {
        return new.target.new_io_ktor_http_UnsafeHeaderException_8be5r0_k$(header);
      }
      static new_io_ktor_http_UnsafeHeaderException_8be5r0_k$(header) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerName, position) {
        return new.target.new_io_ktor_http_IllegalHeaderNameException_97zbc3_k$(headerName, position);
      }
      static new_io_ktor_http_IllegalHeaderNameException_97zbc3_k$(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.$throwableCtor_4);
        $this.headerName_1 = headerName;
        $this.position_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerValue, position) {
        return new.target.new_io_ktor_http_IllegalHeaderValueException_fgjd27_k$(headerValue, position);
      }
      static new_io_ktor_http_IllegalHeaderValueException_fgjd27_k$(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.$throwableCtor_4);
        $this.headerValue_1 = headerValue;
        $this.position_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
var properties_initialized_HttpHeaders_kt_3d6wem;
function _init_properties_HttpHeaders_kt__8vtb1o() {
  if (!properties_initialized_HttpHeaders_kt_3d6wem) {
    properties_initialized_HttpHeaders_kt_3d6wem = true;
    ILLEGAL_HEADER_NAME_CHARS = Companion_instance.of_75jmpt_k$(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(0), _Char___init__impl__6a9atx(32))).plus_an5ph_k$(Companion_instance.of_5gnbr7_k$('"(),/:;<=>?@[\\]{}'));
  }
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance1avhj7ffsen7f,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
